import React from "react";

const Link: React.FC = () => (
<svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" y="0.5" width="40" height="40" rx="9.5" stroke="black"/>
<path d="M13 11V12.4C13 15.7603 13 17.4405 13.654 18.7239C14.2292 19.8529 15.1471 20.7708 16.2761 21.346C17.5595 22 19.2397 22 22.6 22H29M29 22L24 17M29 22L24 27" stroke="black" strokeWidth="1.5" strokeLinecap="square" strokeLinejoin="round"/>
</svg>
);

export default Link;
